<template>
  <div>
    <!--
		<b-col v-if="!isMobile()" cols="12" style="padding-right: 20px">
			<b-row align-h="start">
				<b-col cols="6" align-self="center"><b-form-input v-model="searchedValue" @keyup.enter="getBarcodeList"
						id="smallInput" :placeholder="$t('Search')" />
				</b-col>
				<b-col cols="12" md="auto">
					<b-button size="sm" style="background-color: #7367F0; border-color: #7367F0;" v-on:click="getBarcodeList()">
						<Icon icon="akar-icons:search" width="20" height="20" v-b-tooltip.hover.bottom="$t('List')" />
						{{ $t('List') }}
					</b-button>
				</b-col>
			</b-row>
		</b-col>

		<b-col style="padding-right: 20px" v-else>
			<b-row align-h="start">
				<b-col cols="6" align-self="center"><b-form-input v-model="searchedValue" @keyup.enter="getBarcodeList"
						id="smallInput" :placeholder="$t('Search')" />
				</b-col>
				<b-col cols="6">
					<b-button size="sm" style="background-color: #7367F0; border-color: #7367F0;" v-on:click="getBarcodeList()">
						<Icon icon="akar-icons:search" width="20" height="20" v-b-tooltip.hover.bottom="$t('List')" />
						{{ $t('List') }}
					</b-button>
				</b-col>
			</b-row>
		</b-col>
	-->
    <div class="demo-inline-spacing">
      <b-form ref="form" @submit.prevent="repeateAgain">
        <b-row>
          <b-col cols="12"> </b-col>
          <b-col cols="12"> </b-col>

          <b-col cols="12">
            <b-row>
              <b-col cols="5">
                <h6 style="text-align: center">{{ $t("Barcode") }}</h6>
              </b-col>
              <b-col cols="5">
                <h6 style="text-align: center">{{ $t("Description") }}</h6>
              </b-col>

              <b-col cols="1"> </b-col>
            </b-row>
          </b-col>

          <b-col cols="12">
            <component
              :is="scrollbarTag"
              ref="scroll"
              class="scroll-area--data-list-add-new-barcode-add"
              :settings="settings"
              :key="$vs.rtl"
            >
              <b-row
                v-for="(item, index) in items"
                :id="item.stockBarcodeId"
                :key="item.stockBarcodeId"
                ref="row"
								style="padding-right: 25px"
              >
                <!-- Item Name -->
                <b-col cols="5" style="padding-right: 0">
                  <b-form-group label-for="cost">
                    <b-form-input
                      v-model="item.code"
                      style="font-size: inherit"
                      id="cost"
                      type="text"
                      @keyup.enter="addBarcode(index)"
                      :placeholder="$t('Barcode')"
                      :disabled="item.disabled"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="5" style="padding-right: 0">
                  <b-form-group label-for="cost">
                    <b-form-input
                      v-model="item.description"
                      style="font-size: inherit"
                      id="cost"
                      type="text"
                      :placeholder="$t('Description')"
                      :disabled="item.disabled"
                    />
                  </b-form-group>
                </b-col>
                <!-- Quantity -->

                <b-col v-if="!isMobile()" style="padding-right: 0" cols="2" class="mb-50 ">
                  <b-row v-if="item.stockBarcodeId == ''">
                    <b-col style="padding: 0">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="addBarcode(index)"
                      >
                        <Icon
                          color="#28c76f"
                          icon="ic:baseline-save-all"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="
                          isSidebarActiveProcess = true;
                          deleteBarcodeInd = index;
                        "
                      >
                        <Icon
                          color="#EA5455"
                          icon="ic:baseline-remove-circle"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="updateBarcode(index)"
                      >
                        <Icon
                          color="#7367F0"
                          icon="material-symbols:select-check-box"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-else style="padding-right: 0; padding-left: 0" cols="2" class="mb-50 ">
                  <b-row v-if="item.stockBarcodeId == ''">
                    <b-col style="padding: 0">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="addBarcode(index)"
                      >
                        <Icon
                          color="#28c76f"
                          icon="ic:baseline-save-all"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="
                          isSidebarActiveProcess = true;
                          deleteBarcodeInd = index;
                        "
                      >
                        <Icon
                          color="#EA5455"
                          icon="ic:baseline-remove-circle"
                          width="18"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="updateBarcode(index)"
                      >
                        <Icon
                          color="#7367F0"
                          icon="material-symbols:select-check-box"
                          width="18"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <!-- Remove Button -->
                <b-col cols="12" style="height: 5px"> </b-col> </b-row
            ></component>
          </b-col>
        </b-row>

        <!-- Row Loop -->
      </b-form>
    </div>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="deleteBarcode"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { uuid } from "vue-uuid";
import { isMobile } from "mobile-device-detect";
import { Icon } from "@iconify/vue2";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  props: ["data"],
  data() {
    return {
      deleteBarcodeInd: null,
      isSidebarActiveProcess: false,
      isMobile: function () {
        return isMobile;
      },
      searchedValue: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      items: [
        {
          id: 0,
          description: "",
          code: "",
          disabled: false,
          stockBarcodeId: "",
          stockId: "",
        },
      ],
    };
  },
  components: {
    Icon,
    VuePerfectScrollbar,
  },
  watch: {
    data() {
      this.getStockBarcodesList(this.data.StockId);
    },
  },
  methods: {
    getStockBarcodesListForData() {
      this.getStockBarcodesList(this.data.StockId);
    },
    deleteBarcodeFunc(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteStockBarcode", data.stockBarcodeId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getStockBarcodesList(this.data.StockId);
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data[0].value.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getStockBarcodesList(barcodeId) {
			console.log(barcodeId)
      this.items = [
        {
          id: 0,
          description: "",
          code: "",
          disabled: false,
          stockBarcodeId: "",
          stockId: "",
        },
      ];
      const vs = this.$vs;
      if (barcodeId)
        this.$store
          .dispatch("stock/listStockBarcodesForStock", barcodeId)
          .then((response) => {
            // let costumerList = JSON.parse(response.json);
            if (response.success == true) {
              let allBarcodesData = this.$store.state.stock.StockBarcodes;
              allBarcodesData.forEach((val, index) => {
                this.items.push({
                  id: index + 1,
                  description: val.Description,
                  code: val.Barcode,
                  disabled: false,
                  stockBarcodeId: val.StockBarcodeId,
                  stockId: val.StockId,
                });
              });
            } else
              console.log(
                response.statusText
              ); /*
					vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
          });
    },
    deleteBarcode() {
      this.deleteBarcodeFunc(this.items[this.deleteBarcodeInd]);
    },
    getBarcodeList() {},
    submitBarcode(data) {
      var createdId = uuid.v4();
      const vs = this.$vs;
      const obj = {
        stockBarcodeId: data.stockBarcodeId != "" ? data.stockBarcodeId : createdId,
        unitId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        itemNo: 0,
        barcodeType: 0,
        barcode: data.code,
        description: data.description,
        stockId: this.data.StockId,
      };
      if (data.stockBarcodeId != "") {
        this.$store
          .dispatch("stock/updateStockBarcode", obj)
          .then((response) => {
            if (response.status == 200) {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.$root.$emit("getStockList");
              this.getStockBarcodesList(this.data.StockId);
              this.$root.$emit("getStockListForPalletItems");

              this.$emit("closeSidebar");
              this.initValues();
            } else {
              vs.notify({
                text: response.data[0].value.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      } else {
        delete obj.id;
        this.$store
          .dispatch("stock/addStockBarcode", obj)
          .then((response) => {
            if (response.status == 200) {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getStockBarcodesList(this.data.StockId);
              this.$root.$emit("getStockListForPalletItems");

              this.initValues();
            } else {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      }
    },
    addBarcode(ind) {
      this.submitBarcode(this.items[ind]);
    },
    updateBarcode(ind) {
      this.submitBarcode(this.items[ind]);
    },
    clearFields() {
      this.items = [
        {
          id: 0,
          description: "",
          code: "",
          disabled: false,
          stockBarcodeId: "",
          stockId: "",
        },
      ];
    },
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new-barcode-add {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 230px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
